import React, { useEffect, useState } from "react";

import HttpManager from "../../../../services/HttpManager";
import { useEnviarAprobacion, useTieneCaja } from "../../../../components/aprobaciones/enviarAprobacion";
import { serverError } from "../../../../components/modals/payments/register/registerPaymentModal";

/*
	Promociones › Por Resolver (antes Descuentos › Grupos; Módulos Claros 2026-11-01: con soloCasos no enseña los grupos vivos, que ya
	salen dentro de la ventana de cada acuerdo). (Etapa 4 de cobros, decisión 14 de Esteban). Arriba lo que la vigilancia PROPONE y nadie ha decidido
	(«Por resolver»: grupo achicado, la base de un 2x1 que salió, un cambio de horario con acuerdo, un referido anulado), con el
	antes y después de cada persona; abajo los grupos vivos del plantel con sus miembros y alertas en oro. Nada cambia de precio
	hasta que Supervisión de Caja, Dirección de Ventas o superadmin decidan aquí, con motivo. Todo lo valida el servidor.
*/

const http = HttpManager.getInstance();
const fecha = (d: string | null | undefined) => d ? d.slice(8, 10) + "/" + d.slice(5, 7) + "/" + d.slice(0, 4) : "";
const num = (n: number | null | undefined) => n === null || n === undefined ? "—" : (Math.round(Number(n) * 100) / 100).toLocaleString("es-MX", { maximumFractionDigits: 2 });

const Grupos: React.FC<{ campusId: number; sym: string; onCount?: (n: number) => void; soloCasos?: boolean }> = ({ campusId, sym, onCount, soloCasos }) => {
	const [data, setData] = useState<any>(null);
	const [ver, setVer] = useState<"abiertos" | "todos">("abiertos");
	const [error, setError] = useState<string | null>(null);
	const [decision, setDecision] = useState<Record<number, { resolution: string; notes: string }>>({});
	const [busy, setBusy] = useState<number | null>(null);
	// Fase 2: Caja del plantel arma la decisión y queda Por Aprobar para Supervisión de Caja / Dirección de Ventas.
	const tieneCaja = useTieneCaja();
	const ap = useEnviarAprobacion(campusId);
	const pedir = (c: any) => {
		const d = decision[c.id];
		if (!d || !d.resolution || d.notes.trim().length < 10) return;
		ap.pedir({
			kind: "caso_grupo", titulo: "Por Resolver", motivoInicial: d.notes.trim(),
			data: { issueId: c.id, resolution: d.resolution, notes: d.notes.trim() },
			onDone: () => load(),
		});
	};

	const load = () => {
		http.paymentService.discountGroups(campusId, ver).then((r: any) => { setData(r.data); setError(null); if (onCount) onCount(r.data.open || 0); })
			.catch((e: any) => setError(serverError(e)));
	};
	useEffect(() => { setData(null); load(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [campusId, ver]);

	const decidir = async (c: any) => {
		const d = decision[c.id];
		if (!d || !d.resolution || d.notes.trim().length < 10) return;
		const op = (c.options || []).find((o: any) => o.value === d.resolution);
		if (!window.confirm("¿" + (op ? op.label : d.resolution) + "? " + (d.resolution === "conservar" || d.resolution === "no_transferir" || d.resolution === "no_recuperar"
			? "Nadie cambia de precio." : "Cambia lo que pagan desde su siguiente mensualidad pendiente; lo pagado no se toca."))) return;
		try {
			setBusy(c.id);
			await http.paymentService.resolveGroupIssue(campusId, c.id, d.resolution, d.notes.trim());
			load();
		} catch (e) {
			setError(serverError(e));
		} finally {
			setBusy(null);
		}
	};

	if (!data) return error ? <div className="wdAviso">{error}</div> : <div className="loader" />;
	const abiertos = data.issues.filter((c: any) => c.statusId === 1);
	const cerrados = data.issues.filter((c: any) => c.statusId !== 1);
	const caso = (c: any) => {
		const d = decision[c.id] || { resolution: "", notes: "" };
		const p = c.proposal || {};
		return (
			<div key={"c" + c.id} className={"wdCaso" + (c.statusId === 1 ? " wdCasoAbierto" : "")}>
				<div className="wdCasoCabeza">
					<span className={"wdChip " + (c.statusId === 1 ? "wdChipOro" : "wdChipFilo")}>{c.statusId === 1 ? "Por Resolver" : c.status}</span>
					<b>{c.kindName}</b>
					<span className="wdTenue" style={{ fontSize: 12 }}>Caso #{c.id} · {fecha((c.createdAt || "").slice(0, 10))}{c.notifiedAt ? " · Avisado por WappTeam" : ""}</span>
				</div>
				<div style={{ fontSize: 14, margin: "4px 0" }}>{c.details}</div>
				{p.members && p.members.length ? (
					<table className="wdTabla">
						<thead><tr><th>Persona</th><th>Curso</th><th>Ahora</th><th>{p.mode === "conservar" ? "Se Queda" : "Desde " + fecha(p.from)}</th></tr></thead>
						<tbody>{p.members.map((m: any) => (
							<tr key={"m" + m.enrollmentId}><td>{m.name}{m.newRole === "base" ? <span className="wdTenue"> · paga completo</span> : null}</td><td>{m.course}</td>
								<td>{sym}{num(m.before)}</td><td className={m.after > m.before + 0.009 ? "wdOro" : ""}>{sym}{num(m.after)}</td></tr>
						))}</tbody>
					</table>
				) : null}
				{p.left && p.left.length ? <div className="wdTenue" style={{ fontSize: 13 }}>Salieron: {p.left.map((x: any) => x.name + " (" + x.why + ")").join(" · ")}</div> : null}
				{c.statusId === 1 && (data.canResolve || tieneCaja) ? (
					<div className="wdDecidir">
						{(c.options || []).map((o: any) => (
							<label key={o.value} className="wdOpcion">
								<input type="radio" name={"r" + c.id} checked={d.resolution === o.value} disabled={busy === c.id}
									onChange={() => setDecision({ ...decision, [c.id]: { ...d, resolution: o.value } })} /> {o.label}
							</label>
						))}
						<input className="form-control form-control-sm" placeholder="Motivo" value={d.notes} disabled={busy === c.id}
							onChange={(e) => setDecision({ ...decision, [c.id]: { ...d, notes: e.target.value } })} />
						<button type="button" className="wdBoton wdPrimario" disabled={busy === c.id || !d.resolution || d.notes.trim().length < 10} onClick={() => data.canResolve ? decidir(c) : pedir(c)}>
							{busy === c.id ? "…" : data.canResolve ? "Decidir" : "Enviar a Aprobación"}</button>
					</div>
				) : c.statusId === 1 ? null : (
					<div className="wdTenue" style={{ fontSize: 13 }}>{c.resolutionName ? c.resolutionName + " · " : ""}{c.resolvedBy ? c.resolvedBy + " · " : ""}{fecha((c.resolvedAt || "").slice(0, 10))}{c.resolutionNotes ? " · " + c.resolutionNotes : ""}</div>
				)}
			</div>
		);
	};

	return (
		<>
			{ap.modal}
			{error ? <div className="wdAviso">{error}</div> : null}
			<div className="wdFiltros">
				<select className="form-select form-select-sm" style={{ maxWidth: 220 }} value={ver} onChange={(e) => setVer(e.target.value as any)}>
					<option value="abiertos">Solo por Resolver</option><option value="todos">También los Ya Decididos</option>
				</select>
			</div>
			<h5 className="wdSeccion">Por Resolver {abiertos.length ? <span className="wdChip wdChipOro">{abiertos.length}</span> : null}</h5>
			{abiertos.length ? abiertos.map(caso) : <div className="wdTenue">Nada Por Resolver.</div>}
			{cerrados.length ? <><h5 className="wdSeccion">Decididos</h5>{cerrados.map(caso)}</> : null}
			{soloCasos ? null : <h5 className="wdSeccion">Grupos Vivos</h5>}
			{soloCasos ? null : !data.groups.length ? <div className="wdTenue">Sin grupos en este plantel.</div> : data.groups.map((g: any) => (
				<div key={"g" + g.id} className="wdGrupo">
					<div className="wdCasoCabeza">
						<b>{g.kindName}</b>
						{g.openIssues ? <span className="wdChip wdChipOro">Por Resolver</span> : null}
						{g.alerts ? <span className="wdChip wdChipOro">{g.alerts === 1 ? "1 Alerta" : g.alerts + " Alertas"}</span> : null}
						<span className="wdTenue" style={{ fontSize: 12 }}>Desde {fecha((g.createdAt || "").slice(0, 10))}</span>
					</div>
					{g.members.map((m: any) => (
						<div key={"gm" + m.enrollmentId} className="wdMiembro">
							<span><b>{m.name}</b> <span className="wdTenue">· {m.course} · {m.roleName}</span></span>
							<span>{m.promo ? m.promo : <span className="wdTenue">sin promo</span>}{m.status ? <span className="wdTenue"> ({m.status})</span> : null}</span>
							{m.alert ? <span className="wdOro">{m.alert}</span> : <span />}
						</div>
					))}
				</div>
			))}
		</>
	);
};

export default Grupos;
